import { atom } from 'jotai';

import { createGovReportingFacilityMutationAtom } from '../_graphql/mutationGovReportingFacilityCreate';
import { deleteGovReportingFacilityMutationAtom } from '../_graphql/mutationGovReportingFacilityDelete';
import { updateGovReportingFacilityMutationAtom } from '../_graphql/mutationGovReportingFacilityUpdate';
import { queryGovReportingFacilitiesAtom } from '../_graphql/queryGovReportingFacilities';

import { $govReportingConfigId } from './govReporting.state';

export const $isFacilityAssignmentDialogOpen = atom(false);
export const $editingFacilityAssignment = atom<string | null>(null);

export const $govReportingFacilities = queryGovReportingFacilitiesAtom(
  (get) => {
    const configId = get($govReportingConfigId);
    if (!configId) {
      return { variables: { configurationId: '' }, skip: true };
    }
    return { variables: { configurationId: configId } };
  },
);

export const $createGovReportingFacility =
  createGovReportingFacilityMutationAtom({
    onSuccess: (get) => {
      get($govReportingFacilities).refetch?.();
    },
  });

export const $updateGovReportingFacility =
  updateGovReportingFacilityMutationAtom({
    onSuccess: (get) => {
      get($govReportingFacilities).refetch?.();
    },
  });

export const $deleteGovReportingFacility =
  deleteGovReportingFacilityMutationAtom({
    onSuccess: (get) => {
      get($govReportingFacilities).refetch?.();
    },
  });
